exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboarding-layout {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 8rem 10rem;\n  padding-top: 12rem;\n  padding-bottom: 0;\n}\n\n", ""]);

// exports
